import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { Link } from 'react-router-dom';

function SliderNotas({ newsData, categoriesData }) {
    const filteredNews = categoriesData.map(category => {
        return newsData.find(news => news.category_id === category.id && news.number === 1);
    }).filter(Boolean);

    // const getFirstParagraphHtmlSecond = (html) => {
    //     const tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = html;
    //     const p = tempDiv.querySelector('p');

    //     if (p) {
    //         let text = p.textContent || '';
    //         if (text.length > 100) {
    //             text = text.substring(0, 100) + '...';
    //         }
    //         return `<p>${text}</p>`;
    //     }

    //     let text = tempDiv.textContent || '';
    //     if (text.length > 100) {
    //         text = text.substring(0, 100) + '...';
    //     }
    //     return `<p>${text}</p>`;
    // };

    const getPlainText = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const p = tempDiv.querySelector('p');
    let text = p ? p.textContent : tempDiv.textContent;
    if (text.length > 100) text = text.substring(0, 100) + '...';
    return text;
  };

    return (
        <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
            spaceBetween={30}
            slidesPerView={4}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            touchRatio={1.5}
            grabCursor={true}
            breakpoints={{
                300: {
                    slidesPerView: 1,
                },
                480: {
                    slidesPerView: 2,
                },
                640: {
                    slidesPerView: 3,
                },
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 5,
                },
            }}
        >
            {filteredNews.map(news => (
                <SwiperSlide key={news.id}>
                    <Link to={`/noticias/${news.id}`}>
                        <div style={{ paddingBottom: '2.5rem' }}>
                            <div style={{ width: '100%', height: '200px', overflow: 'hidden', borderRadius: '0.375rem', fontFamily: 'libre Baskerville' }}>
                                <img
                                    src={news.image_url}
                                    alt={news.title}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                            <h2 className="slider-text_notas">{news.title}</h2>
                            <p>{getPlainText(news.body)}</p>
                        </div>
                    </Link>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}

export default SliderNotas;
